module.exports = "<div class=\"container-fluid search-page hidemeontoggle\">\n     <app-tnsearchpanel></app-tnsearchpanel>\n</div>\n<div class=\"container margin-top-flex \">\n  <h1 class=\"page-title\"><b>News</b></h1>\n      <div class=\"row news-list-container\">\n          <div class=\"col-lg-3\" *ngFor=\"let item of NewsList\">\n              <app-tnnewslist-item [newsData]=\"item\"></app-tnnewslist-item>\n          </div>\n      </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/news.component.html
// module id = ../../../../../src/app/themes/default/html/news.component.html
// module chunks = 1